<div class="_rating-component">
    <div class="_stars" [ngClass]="{'_preview': previewRating}" (mouseover)="showPreview($event)" (mouseout)="hidePreview($event)">
        <ng-container [ngTemplateOutlet]="starContainer" [ngTemplateOutletContext]="{score: 1}"></ng-container>
        <ng-container [ngTemplateOutlet]="starContainer" [ngTemplateOutletContext]="{score: 2}"></ng-container>
        <ng-container [ngTemplateOutlet]="starContainer" [ngTemplateOutletContext]="{score: 3}"></ng-container>
        <ng-container [ngTemplateOutlet]="starContainer" [ngTemplateOutletContext]="{score: 4}"></ng-container>
        <ng-container [ngTemplateOutlet]="starContainer" [ngTemplateOutletContext]="{score: 5}"></ng-container>
    </div>

    <ng-template #starContainer let-score="score">
        <div class="_star-container">
            <div class="_star" [id]="score" [ngClass]="{'_active': rating >= score, '_preview_active': previewRating >= score}" (click)="setRating(score)" ></div>
            <p>{{score}}</p>
        </div>
    </ng-template>
    
    <form-validation-error [control]="formControl"></form-validation-error> 
</div>

